import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrentinmumbai() {



    const cardData = {

keyword: "Kia Carens On Rent in Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Kia Carens On Rent in Mumbai for airport transfers, family trips, corporate travel, weddings, local sightseeing, and outstation journeys. Kia Carens is a premium MPV known for its spacious 6/7 seater comfort, modern interiors, smooth ride quality, and ample luggage space, making it ideal for group and family travel. We provide well-maintained Kia Carens vehicles with professional chauffeurs, 24x7 availability, transparent pricing, doorstep pickup across Mumbai, and safe highway driving for a comfortable and hassle-free travel experience.",

topPlaces: [
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a famous hill station in Maharashtra known for scenic viewpoints, strawberry farms, cool weather, and lakes, making it a perfect family road trip destination from Mumbai in Kia Carens."
    },
    {
        title: "Goa",
        description:
            "Goa is India’s most popular beach destination known for nightlife, beaches, water sports, and Portuguese heritage. Kia Carens is ideal for long comfortable group travel from Mumbai."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba, attracting devotees from across India for spiritual darshan and peaceful travel experiences."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is known for vineyards, temples, and Trimbakeshwar Jyotirlinga, making it a popular mix of spiritual and leisure travel destination from Mumbai."
    },
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are scenic hill stations near Mumbai known for monsoon beauty, waterfalls, valleys, and weekend relaxation trips."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a coastal getaway near Mumbai known for clean beaches, forts, and resorts, ideal for short family vacations and weekend trips."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, offering rich historical and UNESCO heritage experiences for culture and history lovers."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is known for Mahalaxmi Temple, cultural heritage, and traditional cuisine, making it a popular pilgrimage destination from Mumbai."
    },
    {
        title: "Matheran",
        description:
            "Matheran is a peaceful hill station near Mumbai known for toy train rides, viewpoints, and pollution-free natural surroundings."
    },
    {
        title: "Pune",
        description:
            "Pune is a major IT and educational hub known for its modern lifestyle, historical forts, and pleasant weather, frequently visited for business and leisure travel."
    }
],



services: [
{
name: "Kia Carens On Rent in Mumbai",
description: "Mumbai Airport Cab offers Kia Carens On Rent in Mumbai service for comfortable, spacious, and reliable travel across the city and outstation routes. Ideal for family trips, group travel, airport transfers, business journeys, weekend getaways, and long-distance travel, we provide well-maintained Kia Carens vehicles with professional chauffeurs. Our drivers ensure smooth highway driving, timely pickup, luggage assistance, and a safe travel experience. With 24x7 availability, transparent pricing, doorstep service, and flexible booking options, we make your journey convenient and stress-free."
},
{
name: "Mumbai Kia Carens Rental",
description: "Mumbai Kia Carens Rental service by Mumbai Airport Cab provides premium and comfortable MPV vehicles for local and intercity travel. Perfect for families and small groups, Kia Carens offers spacious seating, modern interiors, and smooth ride quality. We ensure reliable chauffeurs, clean vehicles, and hassle-free booking for all travel needs."
},
{
name: "Kia Carens Cab Mumbai",
description: "Kia Carens Cab Mumbai service offers safe and comfortable travel in a modern 6-7 seater vehicle. Mumbai Airport Cab ensures professional drivers, timely pickup, and smooth rides for city travel, airport transfers, and outstation journeys."
},
{
name: "Rent Kia Carens Mumbai",
description: "Rent Kia Carens Mumbai service provides easy booking of chauffeur-driven Kia Carens for flexible travel needs. Whether for family trips, business travel, or tours, Mumbai Airport Cab ensures comfort, safety, and reliable transportation."
},
{
name: "Mumbai Kia Carens Taxi Service",
description: "Mumbai Kia Carens Taxi Service offers dependable and comfortable taxi solutions for all types of travel. With experienced chauffeurs and well-maintained vehicles, we ensure smooth and stress-free journeys within and outside Mumbai."
},
{
name: "Kia Carens Outstation Cab Mumbai",
description: "Kia Carens Outstation Cab Mumbai service is designed for long-distance travel with maximum comfort. Mumbai Airport Cab provides spacious seating, safe highway driving, and professional chauffeurs for family and group trips."
},
{
name: "Mumbai Family Kia Carens Cab",
description: "Mumbai Family Kia Carens Cab service ensures safe and comfortable transportation for families. With ample seating, luggage space, and smooth ride quality, Mumbai Airport Cab makes family travel easy and enjoyable."
},
{
name: "Kia Carens Airport Cab Mumbai",
description: "Kia Carens Airport Cab Mumbai service provides timely pickup and drop between Mumbai Airport and your destination. We ensure flight tracking, luggage assistance, and comfortable travel experience for passengers."
},
{
name: "Kia Carens Chauffeur Service Mumbai",
description: "Kia Carens Chauffeur Service Mumbai offers professional drivers with premium MPV vehicles for executive and personal travel. Mumbai Airport Cab ensures punctual service, safe driving, and comfortable journeys."
},
{
name: "Kia Carens Long Distance Mumbai",
description: "Kia Carens Long Distance Mumbai service provides safe and comfortable highway travel for extended journeys. Mumbai Airport Cab ensures well-maintained vehicles and experienced chauffeurs for stress-free trips."
},
{
name: "Kia Carens One Way Cab Mumbai",
description: "Kia Carens One Way Cab Mumbai service offers affordable single-journey travel without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable seating, and reliable intercity travel."
},
{
name: "Kia Carens Round Trip Mumbai",
description: "Kia Carens Round Trip Mumbai service provides complete return journey solutions for family, business, and leisure travel. Mumbai Airport Cab ensures flexible scheduling and comfortable rides."
},
{
name: "Kia Carens Travel Cab Mumbai",
description: "Kia Carens Travel Cab Mumbai service offers reliable transportation for tourism, business, and personal trips. Mumbai Airport Cab ensures safe driving, clean vehicles, and smooth travel experience."
},
{
name: "Kia Carens Weekend Rental Mumbai",
description: "Kia Carens Weekend Rental Mumbai service provides convenient vehicles for short weekend trips and getaways. Mumbai Airport Cab ensures flexible booking and comfortable travel for family and friends."
},
{
name: "Kia Carens Group Travel Mumbai",
description: "Kia Carens Group Travel Mumbai service is ideal for small groups needing spacious and comfortable transportation. Mumbai Airport Cab ensures safe travel, ample seating, and reliable chauffeur service."
},
{
name: "Kia Carens Budget Cab Mumbai",
description: "Kia Carens Budget Cab Mumbai service offers affordable MPV travel without compromising comfort and safety. Mumbai Airport Cab ensures economical pricing and reliable service for all passengers."
},
{
name: "Kia Carens Business Travel Mumbai",
description: "Kia Carens Business Travel Mumbai service is designed for corporate professionals requiring comfortable and reliable transportation. Mumbai Airport Cab ensures punctual service and executive comfort."
},
{
name: "Kia Carens Tour Cab Mumbai",
description: "Kia Carens Tour Cab Mumbai service provides comfortable vehicles for sightseeing and holiday travel. Mumbai Airport Cab ensures flexible itineraries and smooth travel experience."
},
{
name: "Kia Carens Comfortable Ride Mumbai",
description: "Kia Carens Comfortable Ride Mumbai service ensures smooth, safe, and relaxing travel experience for all passengers. Mumbai Airport Cab provides well-maintained vehicles and professional chauffeurs for stress-free journeys."
}
],

tableData: [
["Kia Carens On Rent in Mumbai","Mumbai Kia Carens Rental"],
["Kia Carens Cab Mumbai","Rent Kia Carens Mumbai"],
["Mumbai Kia Carens Taxi Service","Kia Carens Outstation Cab Mumbai"],
["Mumbai Family Kia Carens Cab","Kia Carens Airport Cab Mumbai"],
["Kia Carens Chauffeur Service Mumbai","Kia Carens Long Distance Mumbai"],
["Kia Carens One Way Cab Mumbai","Kia Carens Round Trip Mumbai"],
["Kia Carens Travel Cab Mumbai","Kia Carens Weekend Rental Mumbai"],
["Kia Carens Group Travel Mumbai","Kia Carens Budget Cab Mumbai"],
["Kia Carens Business Travel Mumbai","Kia Carens Tour Cab Mumbai"]
],







whychoose: [
    {
        WhyChooseheading: "Reliable Kia Carens on Rent in Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Kia Carens Rental Services in Mumbai for airport transfers, family vacations, corporate travel, sightseeing tours, weddings, and outstation journeys."
    },
    {
        WhyChooseheading: "Spacious and Modern Family Vehicle",
        WhyChoosedescription: "Kia Carens offers premium interiors, comfortable seating, advanced features, ample legroom, and generous luggage space for a superior travel experience."
    },
    {
        WhyChooseheading: "Perfect for Family and Group Travel",
        WhyChoosedescription: "Whether you are planning a family holiday, weekend getaway, airport transfer, pilgrimage tour, or business trip, Kia Carens provides excellent comfort for every journey."
    },
    {
        WhyChooseheading: "Suitable for Local and Outstation Trips",
        WhyChoosedescription: "Customers can hire Kia Carens for Mumbai city travel as well as destinations like Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Ahmedabad, Ujjain, Jaipur, and other locations."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide seamless airport transportation with Kia Carens vehicles for domestic and international travelers arriving at Mumbai Airport."
    },
    {
        WhyChooseheading: "Professional Chauffeur-Driven Service",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, punctual service, route expertise, and a smooth travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "Customers can choose one-way transfers, round trips, multi-day tours, business travel plans, and customized travel packages according to their requirements."
    },
    {
        WhyChooseheading: "Ideal for Corporate, Tourism, and Event Travel",
        WhyChoosedescription: "From corporate executives and tourists to wedding guests and family groups, Kia Carens is a preferred vehicle for comfortable and premium transportation."
    }
]
};

const faqData = [
    {
        question: "Why choose Kia Carens on Rent in Mumbai?",
        answer: "Kia Carens offers spacious seating, premium interiors, modern features, excellent comfort, and ample luggage space for local and outstation travel."
    },
    {
        question: "Can I book a Kia Carens for Mumbai Airport transfers?",
        answer: "Yes, Kia Carens vehicles are available for airport pickup and drop services from Mumbai Airport."
    },
    {
        question: "Is Kia Carens available for outstation travel?",
        answer: "Yes, customers can hire Kia Carens for Pune, Nashik, Shirdi, Goa, Mahabaleshwar, Ahmedabad, Ujjain, Jaipur, and many other destinations."
    },
    {
        question: "How many passengers can travel in a Kia Carens?",
        answer: "Kia Carens comfortably accommodates up to 6 to 7 passengers along with luggage depending on the seating arrangement."
    },
    {
        question: "Can corporate clients book Kia Carens rentals?",
        answer: "Yes, many corporate organizations, executives, and business travelers prefer Kia Carens for meetings, airport transfers, and official transportation."
    },
    {
        question: "Do you provide chauffeur-driven Kia Carens rentals?",
        answer: "Yes, all Kia Carens bookings from Mumbai Airport Cabs include professional and experienced chauffeurs."
    },
    {
        question: "Can I hire Kia Carens for weddings and family events?",
        answer: "Yes, Kia Carens is frequently booked for weddings, family functions, airport transfers, sightseeing tours, and special occasions."
    },
    {
        question: "Are one-way and round-trip bookings available?",
        answer: "Yes, customers can choose one-way transfers, round trips, airport transfers, and customized travel packages."
    },
    {
        question: "Can I schedule a Kia Carens rental in advance?",
        answer: "Yes, advance booking is recommended to ensure vehicle availability during weekends, holidays, and peak travel seasons."
    },
    {
        question: "How can I book a Kia Carens on Rent in Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sandeep Gokhale",
        feedback:
            "For our family trip to Mahabaleshwar, we selected a Kia Carens and were impressed with the spacious cabin and comfortable seating. The journey was smooth and enjoyable throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priti Shah",
        feedback:
            "We hired a Kia Carens for airport transfers and local sightseeing in Mumbai. The vehicle was modern, well-maintained, and the driver provided excellent service from start to finish.",
        rating: 5
    }
];





























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Kia Carens On Rent in Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/kia-carens-on-rent-mumbai.jpg",
"description": "Book Kia Carens on rent in Mumbai for comfortable family travel, airport transfers, and outstation journeys. Mumbai Airport Cabs offers spacious 6–7 seater Kia Carens with professional chauffeurs, reliable service, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/kia-carens-on-rent-in-mumbai"
}
};







    return (
        <div>

<Helmet>
  <title>Kia Carens on Rent in Mumbai | Family Cab Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Kia Carens on rent in Mumbai for family trips, airport transfers, and outstation travel. Spacious 6–7 seater cab with professional drivers and 24x7 availability."
/>

<meta
 name="keywords"
 content="kia carens on rent in mumbai, mumbai kia carens rental, kia carens cab mumbai, rent kia carens mumbai, mumbai kia carens taxi service, kia carens outstation cab mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kiacarenceonrentinmumbai;